import Swiper from 'swiper';
import { Autoplay, Keyboard, Navigation, Pagination, Thumbs } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/pagination';

const sliderHomeProducts = document.getElementById("home-slider");
if(sliderHomeProducts) {
	new Swiper(sliderHomeProducts, {
		modules: [Autoplay, Navigation],
		loop: true,
		lazy: true,
		autoplay: {
			delay: 4000,
			disableOnInteraction: true,
		},
		speed: 2000,
		slidesPerView: 1,
		spaceBetween: 2,
		// navigation: {
		//     prevEl: '.swiper-button-prev',
		//     nextEl: '.swiper-button-next',
		// },
	});
}

const sliderReviews = document.getElementsByClassName("swiper-reviews-video");
if(sliderReviews) {
	new Swiper(".swiper-reviews-video", {
		modules: [Autoplay, Navigation],
		loop: true,
		autoplay: {
			delay: 3000,
			disableOnInteraction: false
		},
		speed: 1750,
		slidesPerView: 1,
		spaceBetween: 32,
		navigation: {
			prevEl: '.swiper-reviews-video-wrap .swiper-button-prev',
			nextEl: '.swiper-reviews-video-wrap .swiper-button-next',
		},
	});
}

const singleShowroomSliders = document.getElementsByClassName("single-showroom-slider");
if(singleShowroomSliders) {
	new Swiper(".single-showroom-slider", {
		modules: [Keyboard, Pagination],
		keyboard: {
			enabled: true,
		},
		grabCursor: true,
		pagination: {
			el: ".swiper-pagination",
			clickable: true,
		},
		slidesPerView: 1,
		spaceBetween: 16,
	});
}

const timelineSlider = document.getElementsByClassName("timeline");
if(timelineSlider) {
	var timelinePagination = new Swiper(".timeline-pagination", {
		slidesPerView: 1,
		slideToClickedSlide: true,
		// centeredSlides: true
		breakpoints: {
			576: {
				slidesPerView: 2,
			},
			768: {
				slidesPerView: 3,
			}
		}
	});
	
	new Swiper(".timeline", {
		modules: [Navigation, Thumbs],
		slidesPerView: 1,
		grabCursor: true,
		navigation: {
			prevEl: '.timeline-wrap .swiper-button-prev',
			nextEl: '.timeline-wrap .swiper-button-next',
		},
		thumbs: {
			swiper: timelinePagination,
		},
	});
}


const marques = document.querySelector(".swiper-marques");
if(marques) {
	const marquesCount = marques.querySelectorAll(".swiper-slide").length;
	
	let slidesPerView = 3;
	const breakpoints = [6, 5, 4];

	for(let i = 0; i < breakpoints.length; i++) {
		if(marquesCount >= breakpoints[i] * 2) {
			slidesPerView = breakpoints[i];
			break;
		}
	}

	new Swiper(".swiper-marques", {
		modules: [Autoplay],
		loop: true,
		autoplay: {
			delay: 1,
			disableOnInteraction: false
		},
		speed: 1750,
		grabCursor: true,
		slidesPerView: slidesPerView,
		spaceBetween: 16,
		breakpoints: {
			"@0.00": {
			slidesPerView: 2,
			spaceBetween: 16,
			},
			"@0.75": {
			slidesPerView: 3,
			spaceBetween: 16,
			},
			"@1.00": {
			slidesPerView: 4,
			spaceBetween: 16,
			},
			"@1.50": {
			slidesPerView: slidesPerView,
			spaceBetween: 16,
			},
		},
	});
}

const marqueGallery = document.getElementsByClassName("swiper-realisations-marque");
if(marqueGallery) {
	new Swiper(".swiper-realisations-marque", {
		modules: [Pagination],
		grabCursor: true,
		pagination: {
			el: ".swiper-realisations-marque-pagination",
			clickable: true,
		},
		slidesPerView: 1,
		spaceBetween: 16,
	});
}


const reviewsGallery = document.getElementsByClassName("swiper-realisations-reviews");
if(reviewsGallery) {
	new Swiper(".swiper-realisations-reviews", {
		modules: [Pagination],
		grabCursor: true,
		pagination: {
			el: ".swiper-realisations-reviews-pagination",
			clickable: true,
		},
		slidesPerView: 1,
		spaceBetween: 16,
	});
}


const reviews = document.getElementsByClassName("swiper-reviews");
if(reviews) {
	new Swiper(".swiper-reviews", {
		modules: [Pagination],
		grabCursor: true,
		pagination: {
			el: ".swiper-reviews-pagination",
			clickable: true,
		},
		slidesPerView: 1,
		spaceBetween: 16,
	});
}


const categories = document.getElementsByClassName("swiper-categories");
if(categories) {
	new Swiper(".swiper-categories", {
		modules: [Navigation],
		grabCursor: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		slidesPerView: 1,
		spaceBetween: 18,
		breakpoints: {
			404: {
				slidesPerView: 2,
				spaceBetween: 18,
			},
			576: {
				slidesPerView: 2,
				spaceBetween: 18,
			},
			768: {
				slidesPerView: 3,
				spaceBetween: 36,
			},
			992: {
				slidesPerView: 4,
				spaceBetween: 36,
			},
			1200: {
				slidesPerView: 5,
				spaceBetween: 36,
			}
		}
	});
}


const col = document.getElementsByClassName("swiper-col");
if(col) {
	new Swiper(".swiper-col", {
		modules: [Navigation],
		loop: true,
		grabCursor: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		slidesPerView: 1,
		spaceBetween: 18,
	});
}


const products = document.getElementsByClassName("swiper-products");
if(products) {
	new Swiper(".swiper-products", {
		modules: [Navigation],
		loop: true,
		grabCursor: true,
		navigation: {
			nextEl: ".swiper-button-next",
			prevEl: ".swiper-button-prev",
		},
		slidesPerView: 1,
		spaceBetween: 18,
		breakpoints: {
			576: {
				slidesPerView: 2,
				spaceBetween: 18,
			},
			768: {
				slidesPerView: 2,
				spaceBetween: 36,
			},
			992: {
				slidesPerView: 3,
				spaceBetween: 36,
			},
			1200: {
				slidesPerView: 4,
				spaceBetween: 36,
			}
		}
	});
}